import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { UserSelectors } from '@core/account-data';
import { SharedEmailProvidersSelectors } from '@core/email-providers-data';
import { InterviewTemplateScope, InterviewTemplateSelectors } from '@core/interview-templates-data';

@Injectable()
export class AssignedActionsDetailsDialogFacade {
  private readonly store = inject(Store);

  public admins = this.store.selectSignal(UserSelectors.entities());
  public evaluationForms = this.store.selectSignal(
    InterviewTemplateSelectors.entities({ scope: InterviewTemplateScope.Interview }),
  );
  public sharedProviders = this.store.selectSignal(
    SharedEmailProvidersSelectors.entities({ scope: 'visible' }),
  );
}
